function localDateKey(value) {
  if (typeof value === 'string') {
    const isoDate = value.match(/^\d{4}-\d{2}-\d{2}/);
    if (isoDate) return isoDate[0];
  }

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function isPaymentTodayOrFuture(paymentDate, now = new Date()) {
  const paymentDay = localDateKey(paymentDate);
  const today = localDateKey(now);
  return paymentDay !== null && today !== null && paymentDay >= today;
}

module.exports = { isPaymentTodayOrFuture };
